const scenarioQuestion = {
    text: "",
    scenarioId: null,
    questionType: null,
    answerValueType: null,
    nextQuestionId: null,
    minValueCondition: null,
    maxValueCondition: null,
    answerOptions: [],
};

export { scenarioQuestion };
